export default __webpack_public_path__ + "static/media/3233 spice rack C top.269e7bfe.png";